module.exports = __webpack_public_path__ + "static/media/quiz-hint-2-es.4a5e7cfd.vtt";